export default __webpack_public_path__ + "static/media/Filip-avatar.8c919080.jpg";